'use client'

import NavigateDownIcon from '@/app/icons/navigate-down'
import { Interface } from '@/styles/fonts'
import { cn } from '@/util/cn'
import { SelectHTMLAttributes } from 'react'

const optionClassName = 'border-t-giphyLightCharcoal hover:bg-giphyCharcoal cursor-pointer border-t-2 border-solid p-2'

const SelectInput = ({
    options,
    placeholder,
    className,
    ...props
}: {
    options: { label: string; value: string }[]
    className?: string
    placeholder: string
} & SelectHTMLAttributes<HTMLSelectElement>) => {
    return (
        <div className={cn('relative w-[230px]', className)}>
            <select
                className={cn(
                    `h-12 w-full cursor-pointer appearance-none bg-giphyDarkGrey p-3 text-giphyWhite`,
                    Interface.className
                )}
                {...props}
            >
                <option label={placeholder} className={optionClassName} value={''}>
                    {placeholder}
                </option>
                {options.map(({ label, value }) => (
                    <option value={value || label} key={`${label}`} className={optionClassName} onClick={() => {}}>
                        {label}
                    </option>
                ))}
            </select>
            <div className="pointer-events-none absolute top-0 right-0 bottom-0 flex h-12 items-center justify-center">
                <NavigateDownIcon className="m-4 size-4 fill-giphyBlue" />
            </div>
        </div>
    )
}

export default SelectInput
